var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sliderBarDialogShell',{staticClass:"addlinks-dialog",attrs:{"dialog-show":_vm.dialogShow,"dialog-title":_vm.title},on:{"close":_vm.close,"submit":_vm.confirm}},[_c('feishu-form',{ref:"form",attrs:{"form-data":_vm.formData,"editing":true},on:{"submit":_vm.submitHandle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }